var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#C79A00",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m27.071 27.07c1.9529-1.9529 2.9293-4.3093 2.9293-7.07 0-2.76-0.9764-5.1171-2.9293-7.0707-1.9536-1.9529-4.3107-2.9293-7.0707-2.9293-2.7607 0-5.1171 0.9764-7.07 2.9293-1.9536 1.9536-2.93 4.3107-2.93 7.0707 0 2.7607 0.9764 5.1171 2.93 7.07 1.9529 1.9536 4.3093 2.93 7.07 2.93 2.76 0 5.1171-0.9764 7.0707-2.93zm-3.0317-7.4934h-3.555v-3.555h-1.0157v3.555h-3.5543v1.0157h3.5543v3.5543h1.0157v-3.5543h3.555v-1.0157z",
  clipRule: "evenodd",
  fill: "#001246",
  fillRule: "evenodd"
})));
export default SvgPlus;